<template>
  <div class="kalc-container">
    <Budget :view="view" />
  </div>
</template>

<script>
import Budget from "./components/Budget.vue";

export default {
  name: "App",
  components: {
    Budget,
  },
  data() {
    return {
      view: this.rootdata.view ? this.rootdata.view : "kitchen",
    };
  },
};
</script>

<style>
#kalc {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

#kalc h2 {
  margin-top: 1em;
  margin-bottom: 1em;
}

#kalc .kalc-container th {
  border-color: #e5e5e5;
  background-color: #e5e5e5;
  color: #000;
}

#kalc .kalc-container tbody tr:first-child {
  border-top: #e5e5e5;
}

.kalc-container input {
  padding: 5px 3px;
  border-radius: 3px;
  border: 1px solid #e5e5e5;
  font-size: 90%;
  text-align: right;
  width: 100%;
  margin: 0;
}

#kalc tfoot td,
#kalc tfoot th {
  border: 3px solid #e5e5e5;
}

#kalc tfoot th {
  text-align: right;
  padding-right: 10px;
}

.kalc-container input[type="text"] {
  border: 1px solid #e5e5e5;
}
</style>
